// CANONICAL COPY (GH #7115). src/constants/obligations/obl-sdlc-risk-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-sdlc-risk-management',
  title: 'Maintain SDLC risk register and review development risks',
  description:
    'Confirm that risks arising from software development changes are logged, reviewed, and approved on a regular cadence. SDLC risks must be logged at the time of each significant change, assigned a reviewer, have an approved resolution, and be revisited when the underlying control landscape changes.',
  category: 'risk',
  scfIds: ['SCF-DEV-001', 'SCF-DEV-008', 'SCF-RSK-001'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'SDLC risk management procedure is published',
    },
    {
      type: 'manual-attestation',
      description:
        'SDLC risks logged in the last 90 days are reviewed and have an approved resolution or active reviewer assigned',
    },
  ],
  domainActions: [
    { type: 'approve-document', label: 'Approve Procedure' },
    { type: 'upload-artefact', label: 'Upload Attestation' },
  ],
};
